export default __webpack_public_path__ + "static/media/mail-campaign-1.969c2cd5.svg";